import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import Countries from 'Flow2/components/CustomCollections/CustomDataJson/countries.json';
import AppLanguages from 'Flow2/components/CustomCollections/CustomDataJson/languages.json';
export const countriesArr = [...Countries];

export const APP_LANG = [...AppLanguages]

export const DATA_LANGUAGE = [
    { ID: "de", DE: "Deutsch", EN: "German" },
    { ID: "en", DE: "Englisch", EN: "English" },
    { ID: "es", DE: "Spanisch", EN: "Spanish" },
    { ID: "pt", DE: "Portugiesisch", EN: "Portuguese" },
    { ID: "zh", DE: "Chinesisch", EN: "Chinese" },
    { ID: "ru", DE: "Russisch", EN: "Russian" },
    { ID: "sn", DE: "Sprachneutral", EN: "Language Neutral" }
];

export const CONTENT_DATA = [
    { ID: "Unternehmen", DE: "Unternehmen", EN: "Company" },
    { ID: "Produkte", DE: "Produkte", EN: "Products" },
    { ID: "Technologie", DE: "Technologie", EN: "Technology" },
    { ID: "Historie", DE: "Historie", EN: "History" },
    { ID: "Motorsport", DE: "Motorsport", EN: "Motorsport" },
    { ID: "Nachhaltigkeit", DE: "Nachhaltigkeit", EN: "Sustainability" },
    { ID: "Digital", DE: "Digital", EN: "Digital" },
    { ID: "Sport&Lifestyle", DE: "Sport&Lifestyle", EN: "Sport&Lifestyle" },
    { ID: "Footage", DE: "Footage", EN: "Footage" },
    { ID: "9:11 Magazin", DE: "9:11 Magazin", EN: "9:11 Magazin" },
    { ID: "Christophorus", DE: "Christophorus", EN: "Christophorus" },
];

export const STATUS_DATA = [
    { ID: "vorbereitung", DE: "in Vorbereitung", EN: "in preparation" },
    { ID: "bearbeitung", DE: "in Bearbeitung", EN: "in progress" },
    { ID: "freigegeben", DE: "Freigegeben", EN: "shared" },
    { ID: "freigeben_nicht_oeffentlich", DE: "Freigeben - nicht öffentlich", EN: "shared - not public" },
    { ID: "gesperrt", DE: "Gesperrt", EN: "locked" },
    { ID: "geloescht", DE: "Gesperrt & Gelöscht", EN: "Locked & Deleted" },
]

//Basic Metadata - Expert Search
const custompmdbId = {
    inputType: 'CustomDataInput',
    lgMsId: 'customdata.PMDbLb',
    name: 'id'
}

const customppdbId = {
    inputType: 'CustomDataInput',
    lgMsId: 'customdata.PPDbLb',
    name: 'pmdbid'
}

const customtitelDe = {
    inputType: 'CustomDataInput',
    lgMsId: 'expertsearch.deTitleLb',
    name: 'titel_de'
}

const customdescriptionDe = {
    inputType: 'CustomResizableTextArea',
    lgMsId: 'expertsearch.deDescriptionLb',
    name: 'description_de'
}

const customtitelEn = {
    inputType: 'CustomDataInput',
    lgMsId: 'expertsearch.enTitleLb',
    name: 'titel'
}

const customdescriptionEn = {
    inputType: 'CustomResizableTextArea',
    lgMsId: 'expertsearch.enDescriptionLb',
    name: 'title'
}

const customlanguage = {
    inputType: 'CustomDropDown',
    lgMsId: 'expertsearch.LanguagesLb',
    name: 'videolanguage',
    data: DATA_LANGUAGE
};


export const customstatus = {
    inputType: 'CustomDropDown',
    lgMsId: 'customdata.StatusLb',
    name: 'status',
    data: STATUS_DATA
};


const customproducedDate = {
    inputType: "CustomDateGroup",
    lgMsId: "data.ProducedFromLb",
    name: "rechte_produktionsdatum"
};

const customcreatedDate = {
    inputType: "CustomDateGroup",
    lgMsId: "data.CreatedFromLb",
    // name: "date2"
    name: "created"
};

const customcreatedBy = {
    inputType: 'CustomDropDown',
    lgMsId: 'expertsearch.CreatedByLb',
    name: 'createdby'
}

const custommodifiedDate = {
    inputType: "CustomDateGroup",
    lgMsId: "data.ModifiedFromLb",
    name: "date3"
};

const custommodifiedBy = {
    inputType: 'CustomDataInput',
    lgMsId: 'expertsearch.ModifiedByLb',
    name: 'lastmodifiedby'
}

const customformat = {
    inputType: 'CustomDropDown',
    lgMsId: 'customdata.imgFormatLb',
    name: 'bildformat',
    data: [
        { ID: "Hochformat", DE: "Hochformat", EN: "Portrait" },
        { ID: "Querformat", DE: "Querformat", EN: "Landscape" }
    ]
}

const customfiletype = {
    inputType: 'CustomDropdownWithFadeBox',
    lgMsId: 'customdata.fileTypeLb',
    name: 'txt10',
    data: [
        { ID: "video", DE: "Video", EN: "Video" },
        { ID: "pictures", DE: "Foto", EN: "Photo" },
        { ID: "other", DE: "Dokument", EN: "Document" }
    ]
};

const customuploader = {
    inputType: 'CustomDropDown',
    lgMsId: 'expertsearch.uploaderLb',
    name: 'txt4',
}

//Basic Metadata - Upload
const titelDe_upload = {
    inputType: 'CustomDataInput',
    lgMsId: 'upload.deTitleLb',
    name: 'titel_de'
}

const descriptionDe_upload = {
    inputType: 'CustomResizableTextArea',
    lgMsId: 'upload.deDescriptionLb',
    name: 'description_de'
}

const titelEn_upload = {
    inputType: 'CustomDataInput',
    lgMsId: 'upload.enTitleLb',
    name: 'titel'
}
const descriptionEn_upload = {
    inputType: 'CustomResizableTextArea',
    lgMsId: 'upload.enDescriptionLb',
    name: 'title'
}

const customlanguage_upload = {
    inputType: 'CustomDropDown',
    lgMsId: 'upload.videoLanguageLb',
    name: 'videolanguage',
    data: DATA_LANGUAGE
};

const customproductiondate = {
    inputType: 'CustomDateBox',
    lgMsId: "upload.productionDateLb",
    name: "rechte_produktionsdatum"
};

const customuploader_upload = {
    inputType: 'CustomDropDown',
    lgMsId: 'upload.uploaderLb',
    name: 'txt4',
}

export const customstatus_upload = {
    inputType: 'CustomDropDown',
    lgMsId: 'upload.statusLb',
    name: 'status',
    data: STATUS_DATA
};


//Rights
export const customrights = {
    inputType: 'CustomCheckBoxList',
    lgMsId: 'upload.videoRightsLb',
    name: CustomTypes.RIGHTS_FIELD,
    data: [{ id: CustomTypes.RIGHTS_NOTEMP, DE: 'keine zeitliche Einschränkung', EN: 'no temporally restriction' },
    { id: CustomTypes.RIGHTS_NOLOCAL, DE: 'keine lokale Einschränkung', EN: 'no local restriction' },
    { id: CustomTypes.RIGHTS_NOMEDIA, DE: 'keine mediale Einschränkung', EN: 'no medial restriction' }]
}

export const customcountry = {
    inputType: 'CustomDropdownWithFadeBox',
    lgMsId: 'data.localRestrictionLb',
    name: 'rechte_einschraenkunglokal',
    data: []
};

const customtempres = {
    inputType: 'CustomDateBox',
    lgMsId: "data.TemporallyRestrictionLb",
    name: "rechte_einschraenkung"
};

const customdescriptionres = {
    inputType: 'CustomTextArea',
    lgMsId: 'data.DescriptionLb',
    name: 'rechte_beschreibung'
};

const customtimeinout = {
    inputType: 'CustomTimeGroup',
    lgMsId: 'data.tcInOut',
    nameIn: "rechte_tcin",
    nameOut: "rechte_tcout"
};

const custommedia = {
    inputType: 'CustomCheckBoxList',
    lgMsId: 'data.mediaRestrictionLb',
    name: 'rechte_einschraenkungart',
    data: [{ id: "Online", DE: "Online", EN: "Online" },
    { id: "PAG intern", DE: "PAG intern", EN: "PAG intern" },
    { id: "Messe Event", DE: "Messe Event", EN: "Messe Event" },
    { id: "TV", DE: "TV", EN: "TV" }]
}

//Advanced Metadata
const customcontent = {
    inputType: 'CustomDropDown',
    lgMsId: 'customdata.contentsLb',
    name: 'videoinhalte',
    sorted: false,
    data: CONTENT_DATA
}

const customcontent_upload = {
    inputType: 'CustomDropdownWithFadeBox',
    lgMsId: 'customdata.contentsLb',
    name: 'videoinhalte',
    sorted: false,
    data: CONTENT_DATA
}

const custommodels = {
    inputType: 'CustomDropdownWithFadeBox',
    lgMsId: 'customdata.modelsLb',
    name: 'modelle',
    data: []
}

const custommodelyear = {
    inputType: 'CustomDropDown',
    lgMsId: 'customdata.modelYearsLb',
    name: 'year',
    data: []
}

const custommodelyear_upload = {
    inputType: 'CustomDropdownWithFadeBox',
    lgMsId: 'customdata.modelYearsLb',
    name: 'year',
    data: []
}

const customtags = {
    inputType: 'CustomDropdownWithFadeBox',
    lgMsId: 'customdata.tagsLb',
    name: 'tags',
    data: []
}

const customadditionaltags = {
    inputType: 'CustomDataInput',
    lgMsId: 'customdata.additionalLb',
    name: 'zusatztags',
}

const customkfz = {
    inputType: 'CustomDataInput',
    lgMsId: 'metadata.clip.licensePlate',
    name: 'txt6',
}

const customvideotype = {
    inputType: 'CustomDropDown',
    lgMsId: 'customdata.videoTypeLb',
    name: 'videotyp',
    sorted: true,
    data: [
        { ID: "extern", DE: "fertiger Film (extern)", EN: "finished film (external)" },
        { ID: "intern", DE: "fertiger Film (intern)", EN: "finished film (internal)" },
        { ID: "mess", DE: "Messefilm", EN: "Messefilm" },
        { ID: "commercial", DE: "TV-Commercial", EN: "TV-Commercial" },
        { ID: "training", DE: "Training", EN: "Training" },
        { ID: "cleanfeed", DE: "Cleanfeed", EN: "Cleanfeed" },
        { ID: "footage", DE: "Footage", EN: "Footage" },
        { ID: "other", DE: "Sonstiges", EN: "Other" },
        { ID: "test", DE: "Test", EN: "Test" }
    ]
}

const customanimation = {
    inputType: 'CustomCheckBox',
    lgMsId: 'customdata.animationCgiLb',
    name: 'flags',
}

const customClosedCaption = {
    inputType: 'CustomCheckBox',
    lgMsId: 'customdata.closedCaptionLb',
    name: 'eingebrannteuntertitel',
}

//Add To
const customproject = {
    inputType: 'CustomDropDownWithAddButton',
    lgMsId: 'customdata.projectsLb',
    name: 'project',
    data: []
}

const customroom = {
    inputType: 'CustomDropDownWithAddButton',
    lgMsId: 'customdata.roomsLb',
    name: 'room',
    data: []
}

export const basicdataSubmenu = {
    inputType: 'CustomSubmenu',
    lgMsId: 'expertsearch.metadatDataLb',
    name: 'basicdata'
}

export const eSearchBasicData = [basicdataSubmenu, custompmdbId, customppdbId, customtitelDe, customdescriptionDe, customtitelEn,
    customdescriptionEn, customlanguage, customstatus, customproducedDate, customcreatedDate,
    customcreatedBy, custommodifiedDate, custommodifiedBy, customformat, customfiletype, customuploader]

export const eSearchVideoDetails = [customvideotype, customanimation, customClosedCaption]

export const advancedMetadata = [customcontent, custommodels, custommodelyear, customtags, customadditionaltags, customkfz]

const customCreatedByProvider = {
    inputType: 'CustomOutsideCheckBox',
    lgMsId: 'customdata.createdByProvider',
    name: 'sendEmail',
}

export const sendEmail = [customCreatedByProvider];
export const uploadadvancedMetadata = [customcontent_upload, custommodels, custommodelyear_upload, customtags, customadditionaltags, customkfz]

export const uploadBasicData = [titelDe_upload, descriptionDe_upload, titelEn_upload, descriptionEn_upload, customlanguage_upload,
    customproductiondate, customuploader_upload, customstatus_upload, customrights]
export const uploadVideoDetails = [customvideotype, customanimation, customClosedCaption]
export const uploadAddTo = [customproject, customroom]

export const localSection = [customcountry];
export const tempSection = [customtempres, customdescriptionres, customtimeinout];
export const mediaSection = [custommedia];

export const subRightsForm = [
    {
        inputType: 'CustomSubFormSection',
        name: CustomTypes.RIGHTS_NOTEMP,
        data: tempSection
    },
    {
        inputType: 'CustomSubFormSection',
        name: CustomTypes.RIGHTS_NOLOCAL,
        data: localSection
    },
    {
        inputType: 'CustomSubFormSection',
        name: CustomTypes.RIGHTS_NOMEDIA,
        data: mediaSection
    },
];


export const uploadProduction = [
    {
        inputType: 'CustomDataInput',
        lgMsId: 'data.ProCompanyLb',
        name: 'rechte_produktionsfirma',
    },
    {
        inputType: 'CustomDataInput',
        lgMsId: 'data.ContactPersonLb',
        name: 'rechte_kontakt',
    },
    {
        inputType: 'CustomDataInput',
        lgMsId: 'data.ProductionPlaceLb',
        name: 'rechte_produktionsort',
    },
    {
        inputType: 'CustomDataInput',
        lgMsId: 'data.AgencyLb',
        name: 'rechte_agentur',
    },
    {
        inputType: 'CustomDataInput',
        lgMsId: 'data.DirectorLb',
        name: 'rechte_regisseur',
    },
    {
        inputType: 'CustomDataInput',
        lgMsId: 'data.TeamLb',
        name: 'rechte_team',
    },
    {
        inputType: 'CustomDataInput',
        lgMsId: 'data.ProtagonistsLb',
        name: 'rechte_protagonisten',
    }
]

/* ADD_FORM */

export const AddFormConfig = [
    {
        inputType: 'CustomAddDataBox',
        lgMsId: 'customdata.projectname',
        name: 'project',
        title: 'customdata.addProject',
        fMsgIdSubmit: 'customdata.createBtn'
    },
    {
        inputType: 'CustomAddDataBoxWithDropDown',
        lgMsId: 'customdata.roomname',
        name: 'room',
        title: 'customdata.addRoom',
        fMsgIdSubmit: 'customdata.createBtn',
        ddname: 'roomtype',
        ddlgMsId: 'customdata.roomtype',
        data: [
            { ID: "Download", DE: "Download", EN: "Download" },
            { ID: "Upload", DE: "Upload", EN: "Upload" },
            { ID: "Selection", DE: "Selection", EN: "Selection" }
        ]
    }
]

/*
* PROFILE
*/
const firstName = {
    inputType: 'ProfileInput',
    lgMsId: 'profile.firstNameLb',
    name: 'firstName',
    type: 'text'
}

const lastName = {
    inputType: 'ProfileInput',
    lgMsId: 'profile.lastNameLb',
    name: 'lastName',
    type: 'text'
}

const birthday = {
    inputType: 'ProfileDateBox'
}

const email = {
    inputType: 'ProfileInput',
    lgMsId: 'profile.emailLb',
    name: 'email',
    type: 'text'
}

const password = {
    inputType: 'ProfileInput',
    lgMsId: 'profile.passwordLb',
    name: 'password',
    type: 'password'
}

const confirmPassword = {
    inputType: 'ProfileInput',
    lgMsId: 'profile.confirmPasswordLb',
    name: 'confirmPassword',
    type: 'password'
}

const filesRelease = {
    inputType: 'NotificationGroup',
    header: '',
    subheader: 'profile.releaseLb',
    name: 'filesRelease',
}

export const profileUserBasic = [firstName, lastName, birthday, email]
export const profileUserAccount = [password, confirmPassword]
export const profileUserNotification = [/*filesUpdate,*/ filesRelease]


